import { useCallback, useEffect, useMemo } from "react"
import { GenericColumnModel, InteractionManager } from "../models"
import styles from './body.module.scss'
import { Row } from "./Row"
import { ColumnWidthMap } from "../useColumnWidths"
import { TableErrorsMap } from "../../CrudTable/CrudTable"

type Props = {
	columns: GenericColumnModel[]
	rowsData: any[]
	columnWidthMap: ColumnWidthMap
	cellEdited?: (rowData: any, columnId: string, value: any) => Promise<void>
	expand?: (rowData: any) => void
	collapse?: (rowData: any) => void
	onGroupClick?: (groupId: string) => void
	interactionManager: InteractionManager
	errorsMap?: TableErrorsMap
}

export const Body = ({ columns, rowsData, columnWidthMap, cellEdited, expand, collapse, onGroupClick, interactionManager, errorsMap }: Props) => {
	const handleRowClickCallback = useCallback(
		(rowData: any) => {
			interactionManager.click?.(rowData);
		},
		[interactionManager]
	)

	// after row is deleted, we want generic way to deselect that row (instead of doing it in every container when delete happens)
	useEffect(
		() => {
			const doesSelectedRowExists = rowsData.includes(interactionManager.selectedRow);
			if (!doesSelectedRowExists) {
				interactionManager.click?.(undefined);
			}
		},
		[interactionManager, rowsData]
	)

	const rowsContent = useMemo(
		() => rowsData.map((row, rowIndex) => (
			<Row
				key={`row_${rowIndex}`}
				columns={columns}
				rowData={row}
				onClick={handleRowClickCallback}
				interactionManager={interactionManager}
				isSelected={row === interactionManager.selectedRow}
				columnWidthMap={columnWidthMap}
				cellEdited={cellEdited}
				expand={expand}
				collapse={collapse}
				onGroupClick={onGroupClick}
				rowErrorsMap={errorsMap?.[row.id]}
			/>
		)),
		[rowsData, columns, handleRowClickCallback, interactionManager, columnWidthMap, cellEdited, expand, collapse, onGroupClick, errorsMap]
	)

	return (
		<div className={styles.container}>
			{rowsContent}
		</div>
	)
}
